export const SCROLLABLE_CONTAINER_CLASS = '.simplebar-content-wrapper'
